/*
  786 Motion Plus - product carousel tabs (Shop the Products)
  ----------------------------------------------------------
  The section switches panels with display:none and colours a static
  ::after bar, so tab changes snapped. This adds:
    - one underline bar that travels between tabs
    - a height tween so the panel swap does not jump
    - direction-aware card entrance (left/right depending on the tab)
  The section's own logic is untouched; this watches its class changes.
*/
(function () {
  'use strict';

  var html = document.documentElement;
  if (html.classList.contains('motion-off')) return;
  var G = window.gsap;
  if (!G) return;

  function q(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function one(s, r) { return (r || document).querySelector(s); }

  function setup(sec) {
    if (sec.dataset.mpPtb) return;
    sec.dataset.mpPtb = '1';

    var nav = one('.ptb786-tabs', sec);
    var area = one('.ptb786-gallery-area', sec);
    var tabs = q('.ptb786-tab', sec);
    var gals = q('.ptb786-gallery', sec);
    if (!nav || !area || !gals.length) return;

    sec.classList.add('mp-tabs-on');

    /* ---- travelling underline ---- */
    var ind = document.createElement('span');
    ind.className = 'mp-ptb-ind';
    nav.appendChild(ind);

    function activeIndex() {
      for (var i = 0; i < gals.length; i++) {
        if (gals[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    function moveInd(spring) {
      var t = tabs[activeIndex()] || one('.ptb786-tab.is-active', sec);
      if (!t) return;
      G.to(ind, {
        x: t.offsetLeft,
        width: t.offsetWidth,
        autoAlpha: 1,
        duration: spring ? 0.7 : 0,
        ease: spring ? 'elastic.out(1, 0.85)' : 'none',
        overwrite: true
      });
    }

    /* ---- panel swap ---- */
    var lastIdx = activeIndex();
    var lastH = area.offsetHeight;
    var busy = false;

    function swap() {
      if (busy) return;
      busy = true;
      G.delayedCall(0.25, function () { busy = false; });

      var idx = activeIndex();
      var dir = idx >= lastIdx ? 1 : -1;
      lastIdx = idx;

      moveInd(true);

      var gal = gals[idx];
      if (!gal) return;

      var h1 = area.offsetHeight;
      if (lastH && h1 && Math.abs(h1 - lastH) > 4) {
        G.fromTo(area, { height: lastH }, {
          height: h1, duration: 0.5, ease: 'power3.out', clearProps: 'height'
        });
      }
      lastH = h1;

      G.fromTo(gal, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3, ease: 'power2.out' });

      var cards = q('.ptb786-card', gal).slice(0, 24);
      if (cards.length) {
        G.killTweensOf(cards);
        G.fromTo(cards,
          { autoAlpha: 0, x: 46 * dir, y: 12, scale: 0.97 },
          { autoAlpha: 1, x: 0, y: 0, scale: 1, duration: 0.7, ease: 'power3.out',
            stagger: { each: 0.06, from: dir > 0 ? 'start' : 'end' }, clearProps: 'transform' });
      }
    }

    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var el = muts[i].target;
        if (el.classList && el.classList.contains('ptb786-gallery') && el.classList.contains('is-active')) {
          swap();
          return;
        }
      }
    });
    gals.forEach(function (g) { obs.observe(g, { attributes: true, attributeFilter: ['class'] }); });

    /* press feedback on the tab itself */
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('.ptb786-tab');
      if (!btn) return;
      G.fromTo(btn, { scale: 0.94 }, { scale: 1, duration: 0.55, ease: 'elastic.out(1, 0.6)' });
    });

    window.addEventListener('resize', function () {
      lastH = area.offsetHeight;
      G.delayedCall(0.2, function () { moveInd(false); });
    });

    /* place the bar once fonts and images have settled */
    G.delayedCall(0.3, function () { moveInd(false); });
    window.addEventListener('load', function () { G.delayedCall(0.2, function () { moveInd(false); }); });
  }

  function boot(root) {
    try { q('.ptb786-carousel', root || document).forEach(setup); }
    catch (e) { if (window.console) console.warn('[786 ptb]', e); }
  }

  window.MotionPtb = { boot: boot };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else { boot(document); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
